import _ from 'lodash';

export default {
  props: {
    related: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getName(alert) {
      const names = _.map(alert.parsed.match.facts, f => f.name).reverse().sort();
      return names.join(', ');
    },
    getHostName(alert) {
      return _.get(alert.parsed, 'host.hostname', '?');
    },
    getIconName(alert) {
      if (Object.prototype.hasOwnProperty.call(this.$typeDefs.events, alert.parsed.eventType)) {
        return this.$typeDefs.events[alert.parsed.eventType].icon;
      }
      return 'circle';
    },
    relatedUser(uid) {
      const index = _.findIndex(this.related.users, { uid });
      if (index >= 0) {
        return this.related.users[index].name;
      }
      return `${uid}`;
    },
    relatedGroup(gid) {
      const index = _.findIndex(this.related.groups, { gid });
      if (index >= 0) {
        return this.related.groups[index].name;
      }
      return `${gid}`;
    },
    relatedProcess(pid) {
      const index = _.findIndex(this.related.processes, { pid });
      if (index >= 0) {
        return `${this.related.processes[index].name} (${this.related.processes[index].path})`;
      }
      return `${pid}`;
    },
    getEnumString(fields, label, value) {
      const index = _.findIndex(fields, { value: label });
      if (index >= 0) {
        const enumIndex = _.findIndex(
          fields[index].options,
          { value },
        );
        if (index >= 0) {
          return fields[index].options[enumIndex].label;
        }
      }
      return `${value}`;
    },
    getSignerType(value) {
      const index = _.findIndex(this.$typeDefs.types.signing.fields, { value: 'signerType' });
      if (index === -1) {
        return `Unknown ${value}`;
      }
      const optionIndex = _.findIndex(
        this.$typeDefs.types.signing.fields[index].options, { value },
      );
      if (optionIndex === -1) {
        return `Unknown ${value}`;
      }
      return `${this.$typeDefs.types.signing.fields[index].options[optionIndex].label} (${value})`;
    },
  },
};
